import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const PaymentAudit = (filteredInfos, role) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 100
        },
        {
            title: '合同编号',
            dataIndex: 'dataRaw.contractNumbers',
            key: 'contractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contractNumbers'
            },
            filteredValue: filteredInfo.contractNumber || [],
        },
        {
            title: '发票号码',
            dataIndex: 'dataRaw.invoiceInfoDTO.invoiceNumber',
            key: 'invoiceNumber',
            scopedSlots: {
                customRender: 'invoiceNumber'
            }
        },
        {
            title: '发票金额',
            dataIndex: 'dataRaw.invoiceInfoDTO.invoiceAmount',
            key: 'invoiceAmount'
        },
        {
            title: '到款金额',
            dataIndex: 'dataRaw.paymentAmount',
            key: 'paymentAmount',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.paymentAmount || [],
        },
        {
            title: '付款单位',
            dataIndex: 'dataRaw.invoiceTitle',
            key: 'invoiceTitle',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.invoiceTitle || [],
        },
        {
            title: '收款单位',
            dataIndex: 'dataRaw.receivingUnit',
            key: 'receivingUnit',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.receivingUnit || [],
        },
        {
            title: '销售',
            dataIndex: 'dataRaw.sale.name',
            key: 'salesName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.salesName || [],
        },
        {
            title: '客户',
            dataIndex: 'dataRaw.contactName',
            key: 'contactName',
            scopedSlots: {
                customRender: 'contactName'
            }
        },
        {
            title: '到款时间',
            dataIndex: 'dataRaw.paymentDate',
            key: 'paymentDate'
        },

        {
            title: '创建人',
            dataIndex: 'sponsor',
            key: 'sponsor',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.sponsor || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime'
        },
        {
            title: '审核人员',
            dataIndex: 'operator',
            key: 'operator',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            roles: ['ALL', 'SUCCESS', 'DEFEAT'],
            filteredValue: filteredInfo.operator || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '审核时间',
            dataIndex: 'auditTime',
            key: 'auditTime',
            roles: ['ALL', 'SUCCESS', 'DEFEAT']
        },
        {
            title: '审核状态',
            dataIndex: 'status',
            key: 'status',
            scopedSlots: {
                filterDropdown: 'filterStatus',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'status'
            },
            filteredValue: filteredInfo.status || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '认领备注',
            dataIndex: 'remark',
            key: 'remark'
        }
    ].filter(item => item?.roles?.includes(role) || !item.roles || !role)
}
